import React from "react";

const AdditionalContact = (props) => {
  const {
    setContactShow,
    contact,
    deleteContact,
    EditContact,
    clearFormValues,
    handleFormSubmit,
    disabled,
    formValues,
  } = props;
  return (
    <>
      <div className="card contact-card mb-2">
        <div className="card-header">
          <h2>Contact Information</h2>
        </div>
        <div className="card-body">
          <div className="row additional-contact-add-area">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="text-right">
                <button
                  type="button"
                  className="btn add-new-contact-btn"
                  onClick={() => {
                    setContactShow(true);
                  }}
                >
                  <i class="fas fa-plus-square"></i> Add New Contact
                </button>
              </div>
            </div>
            {contact?.map((item, index) => {
              return (
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-4 col-xs-12 mb-2">
                  <div className="added-contact">
                    <div className="contact-edit-options">
                      <i
                        className="far fa-edit"
                        title="Edit"
                        onClick={() => {
                          EditContact(item);
                        }}
                      ></i>
                      <i
                        className="far fa-trash-alt red-tooltip"
                        title="Delete"
                        onClick={() => {
                          deleteContact(item);
                        }}
                      ></i>
                    </div>
                    <i className="far fa-user-circle"></i>
                    <h5>{item.name}</h5>
                    <span>{item.email}</span>
                    <p>{item.designation}</p>
                    <p>{item.phone}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
              <div className="save-btns">
                <button className="btn cancel-btn" onClick={clearFormValues}>
                  Cancel
                </button>
                <button
                  className="btn save-btn"
                  onClick={handleFormSubmit}
                  disabled={disabled}
                >
                  {" "}
                  {!formValues?.id > 0 ? "Save" : "Update"}{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='card mt-3'>
                <div className='card-body p-0'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div class="accordion" id="history">
                                <div class="card">
                                    <div class="card-header" id="historyhead1">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#history1"
                                            aria-expanded="true" aria-controls="history1">History</a>
                                    </div>

                                    <div id="history1" class="collapse show" aria-labelledby="historyhead1" data-parent="#history">
                                        <div class="card-body p-0">
                                            <div className='history-table-sec'>
                                                <table className="table table-striped table-borderless">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" className="sort-icon">Date</th>
                                                            <th scope="col">Time</th>
                                                            <th scope="col">Name</th>
                                                            <th scope="col">Description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="text-align">05-May-2022</td>
                                                            <td>10:15 Am</td>
                                                            <td>Arun Gopalakrishnan</td>
                                                            <td>Changed Phone number 4466091 to 4466095</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-align">05-May-2022</td>
                                                            <td>10:15 Am</td>
                                                            <td>Arun Gopalakrishnan</td>
                                                            <td>Changed Phone number 4466091 to 4466095</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-align">05-May-2022</td>
                                                            <td>10:15 Am</td>
                                                            <td>Arun Gopalakrishnan</td>
                                                            <td>Changed Phone number 4466091 to 4466095</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
    </>
  );
};

export default AdditionalContact;
